export default "__VITE_ASSET__662e719b__"